import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  onScrollToTop?: () => void;
}

export default function Navbar({ onScrollToTop }: NavbarProps) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dongzuo', label: '电影' },
    { to: '/category/dianshiju', label: '电视剧' },
    { to: '/category/donghua', label: '动画' },
    { to: '/category/jilupian', label: '纪录片' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            onClick={onScrollToTop}
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-lg text-white"></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
              农民影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/90 hover:text-white'
                }`}
                onClick={onScrollToTop}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className={`relative ${isScrolled ? 'text-foreground-700' : 'text-white/80'}`}>
              <i className="ri-search-line text-lg"></i>
            </div>
            <Link
              to="/about"
              onClick={onScrollToTop}
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-vip-crown-line"></i>
              了解更多
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center ${isScrolled ? 'text-foreground-900' : 'text-white'}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
                onClick={onScrollToTop}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}

import { useState } from 'react';